const els = document.querySelectorAll('.filter__count');

for (let el of els) {
    window.addEventListener('liveFilterUpdate', e => {
        el.innerText = e.data.count;
    });
};
